export const BASKET_SET = "BASKET_SET";
export const SHIPPING_SET = "SHIPPING_SET";
export const STORE_SET = "STORE_SET";
